<template lang="pug">
	.orders-table(v-if="Object.keys(orders).length" :time_range="timeFilter" :active_status="activeStatus")
		.orders-table-scroller
			table
				thead
					tr
						th(v-for="column in columns" :class="'th-' + column.class" @click="sortTable(column.property)")
							div
								span {{column.title}}
								i.fa.fa-sort(v-if="!sorting.includes(column.property)")
								i.fa.fa-sort-desc(v-else-if="sorting.includes('desc')")
								i.fa.fa-sort-asc(v-else)
						th
				tbody
					tr(v-for="order in ordersWithImpressionsFiltered")
						td(v-for="column in columns" :class="'td-' + column.class")
							span(v-if="column.type === 'currency'") {{parseFloat(order[column.property]).toLocaleString(column.currency.locale, {style: 'currency', currency: column.currency.currency, minimumFractionDigits: column.currency.fractionDigits, maximumFractionDigits: column.currency.fractionDigits})}}
							span(v-else-if="column.type === 'icon'")
								i.fa.fa-play(v-if="order.active")
								i.fa.fa-pause(v-else)
							span(v-else-if="column.type === 'date'") {{order.latest_event ? order.latest_event.add(timezoneOffset, 'minute').format('D MMM YYYY HH:mm') : 'N/A'}}
							span(v-else-if="columns.type === 'impressions'") {{order[column.property].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}
							span(v-else) {{order[column.property]}}
						td.td-options
							ActionsDropdown(:type="'order'" :index="order.id" :order="order")

</template>

<script>
import Screen 				from './../../mixins/screen';
import {Order} 				from "@/services/Order";
import ActionsDropdown from "@/components/CustomControls/ActionsDropdown";
import _ from "lodash";

export default {
	name: 'OrdersTable',
	components: {
		ActionsDropdown
	},
	mixins: [Screen],
	screen: {
		updateOn: ["Orders Loaded", "Impressions For Orders Fetched"],
		events: {
		}
	},
	props: ["orders", "timeFilter", "activeStatus"],
	data() {

		this.Order = Order;

		this.ordersWithImpressions = [];
		this.ordersWithImpressionsFiltered = [];

		this.timezoneOffset = new Date().getTimezoneOffset();


		return {
			showed: true,
			sorting: 'id|asc',
			columns: [
				{
					title: 'Id',
					property: 'id',
					class: 'id',
				},
				{
					title: 'Status',
					property: 'active',
					type: 'icon',
					class: 'id'
				},
				{
					title: 'Name',
					property: 'name',
					class: 'name'
				},
				{
					title: 'Last',
					property: 'latest_event',
					class: 'id',
					type: 'date'
				},
				{
					title: 'Impressions',
					property: 'installs',
					class: 'metric',
					type: 'impressions'
				},
				{
					title: 'CPM',
					property: 'impression_price',
					class: 'metric',
					type: 'currency',
					currency: {
						locale: 'en-US',
						currency: 'USD',
						fractionDigits: 3
					}
				},
				{
					title: 'Spend',
					property: 'spend',
					class: 'metric',
					type: 'currency',
					currency: {
						locale: 'en-US',
						currency: 'USD',
						fractionDigits: 2
					}
				}
			]
		}
	},
	watch: {
		timeFilter() {
			Server.sendToSocket({
				FetchImpressionsForOrders: {
					ordersIds: Object.keys(this.orders),
					timeFilter: this.timeFilter
				}
			});
		},
		activeStatus() {
			this.ordersWithImpressionsFiltered = this.ordersWithImpressions.filter(order => this.filterStatus(order.active));
		}
	},
	methods: {
		collectData() {

			this.ordersWithImpressions = TrackingEvent.getOrdersWithImpressions();

			this.sortTable(this.sorting.split('|')[0], false);

			if (!this.ordersWithImpressions || !TrackingEvent.lastUpdateForOrders && Object.keys(this.orders).length) {
				Server.sendToSocket({
					FetchImpressionsForOrders: {
						ordersIds: Object.keys(this.orders),
						timeFilter: this.timeFilter
					}
				});
			}

		},
		editOrder(order) {
			Broadcast.call("Show OrderActionsEdit", [order]);
		},
		deleteOrder(order) {
			Broadcast.call("Show OrderActionsDelete", [order]);
		},

		sortTable(property, reverse = true) {

			const currentSort = this.sorting.split('|');

			let newDir = currentSort[1];
			if (currentSort[0] === property && reverse) {
				if (currentSort[1] === 'asc') newDir = 'desc';
				else newDir = 'asc';
			}

			this.sorting = property + '|' + newDir;

			this.ordersWithImpressions.sort((a, b) => {
				if (newDir === 'asc') {
					return _.get(a, property, 0) >= _.get(b, property, 0) ? 1 : -1;
				} else {
					return _.get(a, property, 0) >= _.get(b, property, 0) ? -1 : 1;
				}

			});

			this.ordersWithImpressionsFiltered = this.ordersWithImpressions.filter(order => this.filterStatus(order.active));

			this.$forceUpdate();

		},
		filterStatus(value) {
			if (this.activeStatus === 'all') return true;
			if (this.activeStatus === 'active') return Boolean(value) === true;
			if (this.activeStatus === 'inactive') return Boolean(value) === false;
		},
	}
}

</script>

<style lang="sass">

	.orders-table
		width: 100%
		display: flex
		flex: 1
		padding: 10px 30px 10px 30px
		color: white
		overflow: hidden
		min-height: 100px

		>.orders-table-scroller
			width: 100%
			overflow: hidden auto

			&::-webkit-scrollbar
				appearance: none
				width: 5px
			&::-webkit-scrollbar-thumb
				background-color: #343434
				border-radius: 15px

	table
		border: 0
		width: 100%
		padding: 0
		border-spacing: 0
		border-collapse: separate
		margin: 0
		font-size: 13px
		border-radius: 15px
		overflow: hidden

		>thead

			>tr
				background-color: #25252f

			th > div
				display: inline-flex
				cursor: pointer
				user-select: none
				align-items: center

			th > div > i
				padding-left: 5px

			th.th-name
				width: 250px
				padding-left: 10px

			th.th-id
				text-align: center

		>tbody
			background-color: #2d2f3b

			tr
				white-space: nowrap

				.td-id
					width: 70px
					text-align: center

				.td-name
					padding-left: 10px

		tr
			border-bottom: 1px solid #39383d

</style>
